import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService, BASE_API_URL, LocalStatusFacade } from '@cnt-workspace/data-access';
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';

// Copy of cnt-landing's unauthenticated-error.interceptor.ts — signs the admin
// out when our own API answers 401.
export const adminUnauthenticatedErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const statusFacade = inject(LocalStatusFacade);

  return next(request).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && err.url?.includes(BASE_API_URL)) {
        statusFacade.loggedIn$.pipe(first()).subscribe((loggedIn) => {
          if (loggedIn) {
            void auth.signOut('You have been logged out by the server');
          }
        });
        return throwError(() => new Error('You have been logged out by the server'));
      }
      return throwError(() => err);
    }),
  );
};
